import React from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSalonAccess } from '../../../context/SalonAccessContext';

const FIRST_ROUTE_BY_PERMISSION = [
  ['appointments.view', '/pro/rendez-vous'],
  ['salon.view', '/pro/salon'],
  ['salon.manage_theme', '/pro/salon'],
  ['clients.view', '/pro/client'],
  ['employees.view', '/pro/employe/membre-de-groupe'],
  ['managers.view', '/pro/gestionnaires'],
  ['client_messages.access', '/pro/client-messages'],
];

export const firstPermittedProfessionalRoute = (canSee) =>
  FIRST_ROUTE_BY_PERMISSION.find(([code]) => canSee(code))?.[1] || '/pro/profile';

const SalonPermissionGate = ({ permission, children }) => {
  const { t } = useTranslation();
  const { canSee, isLoading, isError, hasNoAuthorizedSalon } = useSalonAccess();

  if (isLoading) {
    return <Box sx={{ display: 'grid', placeItems: 'center', py: 8 }}><CircularProgress /></Box>;
  }
  if (isError) {
    return <Alert severity="error">{t('pro_manager_access.load_error', 'Impossible de charger les accès.')}</Alert>;
  }
  if (hasNoAuthorizedSalon) {
    return <Alert severity="warning">{t('pro_manager_access.no_authorized_salon', 'Aucun salon autorisé')}</Alert>;
  }
  if (!canSee(permission)) {
    return <Navigate to={firstPermittedProfessionalRoute(canSee)} replace />;
  }
  return children;
};

export default SalonPermissionGate;
